import { AxiosError } from 'axios';
import { UserGroupAccessConfigurationResponse } from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import { GET_DATA_ARCHIVAL_REPORT_FILTER_ARCHIVAL_LEVEL_URL } from '../../constants/apiUrls';
import { GET_DATA_ARCHIVAL_REPORT_FILTER_ARCHIVAL_LEVEL } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: UserGroupAccessConfigurationResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetDataArchivalReportFilterArchivalLevel = ({ onError, onSuccess }: Input) => {
  const getDataArchivalReportFilterArchivalLevel = async () => {
    const res = await axiosClient.get<UserGroupAccessConfigurationResponse>(
      GET_DATA_ARCHIVAL_REPORT_FILTER_ARCHIVAL_LEVEL_URL
    );

    return res.data;
  };

  return useCustomQuery(
    [GET_DATA_ARCHIVAL_REPORT_FILTER_ARCHIVAL_LEVEL],
    getDataArchivalReportFilterArchivalLevel,
    {
      onSuccess,
      onError,
    }
  );
};
